export const buildingDisplayName = 'Building';
export const buildingsDisplayName = 'Buildings';
export const mainMenuPlacement: string = 'Left'; // Left, Top
